<template>
	<button
		class="prebet-match__odd"
		@click="addToBetslip()"
		:class="{ selected: amISelected }"
	>
		<!-- <span class="prebet-match__odd__odd-key">{{
			odd.display | truncate(6)
		}}</span> -->
		<span class="prebet-match__odd__odd-value bold">{{
			odd.odd_value || "-"
		}}</span>
	</button>
</template>
<script>
import store from "../../store";
export default {
	name: "match-odd",
	props: ["odd", "match", "market", "matchGridPosition"],
	methods: {
		getMulti(oddsLen, textLen) {
			let multi = 1;
			if (oddsLen % 2 == 0) multi = 2;
			if (oddsLen % 3 == 0) multi = 3;
			if (textLen >= 8 && oddsLen != 3) multi = 2;
			if (textLen <= 5) multi = 4;
			if (textLen <= 5 && oddsLen % 2 == 0 && oddsLen % 4 != 0) multi = 2;
			if (textLen <= 5 && oddsLen % 3 == 0) multi = 3;
			if (textLen <= 5 && oddsLen % 2 == 0 && oddsLen > 8) multi = 4;
			if (textLen > 15) multi = 1;
			return multi;
		},
		addToBetslip() {
			var vm = this;
			if (!vm.odd.odd_value) return;

			let bet = {
				matchId: vm.match.match_id,
				odd: vm.odd,
				type: vm.market.sub_type_id,
				market: vm.market.name,
				display: `${vm.match.home_team} vs. ${vm.match.away_team}`,
				startTime: vm.match.start_time,
				live: false,
				active: true,

				// Coola payload
				profile_id: this.$store.getters.user.id,
				app_name: "MOBILE_WEB",
				parent_match_id: vm.match.parent_match_id,
				game_description: `${vm.match.home_team} vs. ${vm.match.away_team}`,
				bet_pick: vm.odd.odd_key,
				sub_type_id: vm.market.sub_type_id,
				market_name: vm.market.name,
				odd_key: vm.odd.odd_key,
				odd_value: vm.odd.odd_value,
				special_bet_value: vm.odd.special_bet_value || "",
				bet_type: "prebet",
				home_team: vm.match.home_team,
				away_team: vm.match.away_team,
				is_esport: vm.match.is_esport,
				match_grid_position: vm.matchGridPosition,
				provider:vm.match.provider
			};

			// if i am selected, remove me
			if (
				store.state.betSlip.find(function (bet) {
					return bet.matchId == vm.match.match_id && bet.odd == vm.odd;
				})
			) {
				this.removeFromBetslip();
				return;
			}

			// if my match has a selected odd, remove it
			if (
				store.state.betSlip.find(function (bet) {
					return bet.matchId == vm.match.match_id;
				})
			)
				this.removeFromBetslip();

			/*
          add me to betslip after confirming that i'm not already there 
          and removing my match if it already exists
      */
			vm.analyticsTrack("betSlip", "add", {
				appName: "MOBILE_WEB",
				betType: bet.bet_type,
				display: bet.display,
				matchId: bet.matchId,
				profileId: window.localStorage.getItem("user")
					? JSON.parse(window.localStorage.getItem("user")).id
					: "",
				betPick: bet.bet_pick,
				homeTeam: bet.home_team,
				awayTeam: bet.away_team,
				oddValue: bet.odd_value,
				market: bet.market,
				startTime: bet.startTime,
			});
			store.commit("addToBetslip", bet);

			this.$emit("added", bet);
		},

		removeFromBetslip() {
			this.selected = "";
			var vm = this;
			const bet = {
				matchId: vm.match.match_id,
				odd: vm.odd,
				type: vm.market.sub_type_id,
				market: vm.market.name,
				display: `${vm.match.home_team} vs. ${vm.match.away_team}`,
				startTime: vm.match.start_time,
				live: false,
				active: true,

				// Coola payload
				profile_id: this.$store.getters.user.id,
				app_name: "MOBILE_WEB",
				parent_match_id: vm.match.parent_match_id,
				game_description: `${vm.match.home_team} vs. ${vm.match.away_team}`,
				bet_pick: vm.odd.odd_key,
				sub_type_id: vm.market.sub_type_id,
				market_name: vm.market.name,
				odd_key: vm.odd.odd_key,
				odd_value: vm.odd.odd_value,
				special_bet_value: vm.odd.special_bet_value || "",
				bet_type: "prebet",
				home_team: vm.match.home_team,
				away_team: vm.match.away_team,
				is_esport: vm.match.is_esport,
				provider: vm.match.provider
			};
			store.commit("removeFromBetslip", bet);
			this.$emit("removed", bet);
		},
	},
	computed: {
		amISelected() {
			var vm = this;
			let me = store.state.betSlip.filter(function (bet) {
				return (
					bet.matchId == vm.match.match_id && // my match
					bet.type == vm.market.sub_type_id && // my subtype
					bet.odd.display == vm.odd.display && // 👇 my odd - doing this because vuex adds reactive props to betslip values
					bet.odd.odd_key == vm.odd.odd_key
				);
			});
			return me.length > 0;
		},
	},
};
</script>
<style lang="scss" scoped>
.prebet-match__odd {
	background-color: var(--light-gray);
	color: var(--black);
	z-index: 2;
	display: flex;
	flex-direction: row;
	justify-content: center;
	border-radius: 15px;
	align-items: center;
	padding: 8px 5px;
	border: none;
	&__odd-key {
		flex: 4;
		text-align: left;
		font-size: var(--font-small);
		font-weight: var(--font-weight-normal);
		line-height: 14px;
	}
	&__odd-value {
		flex: 1;
		font-size: var(--font-medium);
	}
	&.selected {
		background-color: var(--yellow);
		color: var(--always-black);
	}
}
</style>
